import React from 'react';
import useWindowDimensions from './useWindowDimensions';
import { Modal } from 'antd';
import HSButton from './Button';

type Props = {
    message: string;
    visible: boolean;
    title: string;
    onCancel: () => void;
    onOk: () => void;
    loader?: boolean;
};

const Confirmation: React.FC<Props> = ({ message, visible, title, onCancel, onOk, loader }) => {
    const { width } = useWindowDimensions();
    return (
        <Modal
            className="modal_table_block md:my-2 md:mx-auto md:h-auto"
            width={width > 730 ? '30%' : '100%'}
            title={title}
            centered
            footer={null}
            open={visible}
            onCancel={onCancel}
            okText={'Confirm'}
        >
            <div>
                <p>{message}</p>
                <div className="flex justify-end py-2">
                    <div className="px-4">
                        <HSButton title="No" light={true} onClick={onCancel} />
                    </div>
                    <div>
                        <HSButton title="Yes" onClick={onOk} loading={loader} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Confirmation;
